import { useAsyncPaginate } from './hooks/useAsyncPaginate';
import { useComponents } from './hooks/useComponents';

export function withAsyncPaginate(SelectComponent) {
  const WithAsyncPaginate = (props) => {
    const {
      components,
      selectRef,
      useComponents: useComponentsProp,
      useAsyncPaginate: useAsyncPaginateProp,
      cacheUniqs,
      ...rest
    } = props;

    const asyncPaginateProps = useAsyncPaginateProp(rest, cacheUniqs);

    const processedComponents = useComponentsProp(components);

    return (
      <SelectComponent
        {...props}
        {...asyncPaginateProps}
        components={processedComponents}
        ref={selectRef}
      />
    );
  };

  WithAsyncPaginate.defaultProps = {
    selectRef: null,
    cacheUniqs: [],
    components: {},
    useComponents,
    useAsyncPaginate,
  };

  return WithAsyncPaginate;
}
